import { global } from './global';

module.exports = {
    fulfilmentSelector: {
        fulfilmentMethodSelectorTitle: 'How would you like to receive your groceries?',
        selectedAddressTitle: 'Today\'s shop:',
        manualAddressTitle: 'Enter a new delivery address',
        pickupOptionSubheading: '$30 min. spend',
        deliveryOptionSubheading: '$50 min. spend',
        pickupStoresPerPage: 3,
        pickupStoreInputLabel: 'Pick up from',
        deliveryAddressInputLabel: 'Deliver to',
        manualAddressStreet1InputLabel: 'Street Address 1',
        manualAddressStreet2InputLabel: 'Street Address 2',
        manualAddressPostcodeInputLabel: 'Postcode',
        manualAddressSuburbInputLabel: 'Suburb',
        welcomeMessage: 'Welcome,',
        numberOfKeystrokesToTriggerSearch: 4,
        searchByCurrentLocationLabel: 'Using your current location',
        confirmLaterLabel: 'Confirm later',
        notServicedNotificationTitle: 'Unable to Deliver',
        notServicedNotificationMessage: `You may be in an unserviced or remote area. Please contact our  <a href='${global.wowCustomerCareUrl}' onclick="utag.link({'event.Action':'click','event.Category':'Fulfilment Modal', 'event.Hash': Math.random(0, Number.MAX_VALUE).toString(36), 'event.Label': 'Non serviced address error', 'event.Name': 'Hyperlink_click', 'site.Section': 'shop:discover'});">Customer Care Team</a> for options, alternatively you could choose Pick up.`,
        remoteOrderNotificationTitle: 'Rural and Remote Customers',
        remoteOrderNotificationMessage: "If you live in a remote area we might have to set you up differently. Please speak to our <a href='http://woolworths.com.au' onclick=\"utag.link({'event.Action':'click','event.Category':'Fulfilment Modal', 'event.Hash': Math.random(0, Number.MAX_VALUE).toString(36), 'event.Label': 'Remote Order Info', 'event.Name': 'Hyperlink_click', 'site.Section': 'shop:discover'});\">Customer Care Team</a>",
        addressRequiredError: 'Address is required.',
        locationRequiredError: 'Location is required.',
        errorImageURL: 'https://www.woolworths.com.au/content/spilledmilk-373x322.png',
        errorTitle: 'Oops!',
        errorMessage: "We're having some issues. We'll send you to the Homepage while we try and figure this out.",
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/fulfilment-selector.js